var support = "https://shopfront-cdn.tekoapis.com/static/f5ca93aa40fe18ed.svg";

export { support as default };
